import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  clearSelectedTrims,
  removeSelectedTrim,
  selectErrors,
  selectGlobalInfo,
  selectIsShowFooter,
  selectSelectedTrims,
  updateErrors,
} from './store/global/reducer';
import useSetCompareBtn from './hooks/useSetCompareBtn';
import { COMPARE_PARAM_KEY, SEGMENT_PARAM_KEY, SELECTED_TRIMS_COMPARE_COOKIE_NAME, TRIM_PARAM_KEY } from './helpers/constant';

import ErrorDifferentSegments from '../global/components/compare/ErrorDifferentSegments';
import CompareFooter from '../global/components/compare/CompareFooter';
import { setLocalStorage } from '../../../utils';

const FindAndCompareFooterRoot = () => {
  const dispatch = useDispatch();
  const { labels } = useSelector(selectGlobalInfo);
  const errors = useSelector(selectErrors);
  const isShowFooter = useSelector(selectIsShowFooter);
  const selectedTrims = useSelector(selectSelectedTrims);

  const { hasCompareBtn } = useSetCompareBtn();

  const handleAddMoreTrim = () => {
    window.location.href = `/find-and-compare?${SEGMENT_PARAM_KEY}=${selectedTrims[0].vehicleType?.toLowerCase()}&${TRIM_PARAM_KEY}=${selectedTrims.map((trim) => `${trim.modelId}-${trim.colorCode}`).join(',')}`;
  };

  const handleRemoveTrim = (modelId) => {
    dispatch(removeSelectedTrim(modelId));
  };

  const handleCompare = () => {
    window.location.href = `/find-and-compare?${TRIM_PARAM_KEY}=${selectedTrims.map((trim) => `${trim.modelId}-${trim.colorCode}`).join(',')}&${COMPARE_PARAM_KEY}=true`;
  };

  const handleClear = () => {
    dispatch(clearSelectedTrims());
  };

  const handleCloseErrors = (data) => {
    dispatch(updateErrors(data));
  };

  const updateSelectedTrimsUrlParams = (trims) => {
    setLocalStorage(SELECTED_TRIMS_COMPARE_COOKIE_NAME, JSON.stringify(trims));
  };

  return (
    <>
      {isShowFooter && hasCompareBtn && <CompareFooter
        labels={labels}
        selectedTrims={selectedTrims}
        isDifferentSegment={errors.isDifferentSegment}
        handleAddMoreTrim={handleAddMoreTrim}
        handleRemoveTrim={handleRemoveTrim}
        handleCompare={handleCompare}
        handleClear={handleClear}
        updateSelectedTrimsUrlParams={updateSelectedTrimsUrlParams}
      />}
      {errors.isDifferentSegment && (
        <ErrorDifferentSegments
          isShowPopup={errors.isDifferentSegment}
          labels={labels.differentSegments}
          onClose={() => handleCloseErrors({ isDifferentSegment: false })}
        />
      )}
    </>
  );
};

export default FindAndCompareFooterRoot;